import React, { Component, Fragment, useEffect } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import Header from '../NewProfile/Header';
import SideBarContent from '../SideBar/SideBarContent';
import ScrollLock from 'react-scrolllock';
import './Privacy.css';
import NYCFooter from '../Layout/NYCFooter';
import SFFooter from '../Layout/SFFooter';
import TorontoFooter from '../Layout/TorontoFooter';
import { Helmet } from 'react-helmet';
import OttawaFooter from '../Layout/OttawaFooter';

const NewPrivacy = () => {
  const history = useHistory();
  const pathname = history.location.pathname;
  return (
    <Fragment>
      <div className="new-terms">
        <div className="privacy__title">
          <h1>Privacy & Policies</h1>
        </div>
        <div className="container">
          <Helmet>
            <title>Privacy & Policies | Autzu</title>
            <meta name="description" />
          </Helmet>
          {window.innerWidth >= 768 && (
            <Header persistentTitle title="Privacy" />
          )}

          <div className="privacy__container">
            <div className="privacy__content">
              <div className="privacy__content--container">
                <div className="privacy__header" />
                <p className="privacy__body">
                  Autzu takes your privacy seriously. To make sure you stay
                  informed, we've clearly outlined our privacy policy for
                  you to read through and to acknowledge before signing up
                  to work with us. It may be updated from time to time, so
                  make sure you go through it often to get the latest on
                  how we make use of and safeguard your personal
                  information.
                </p>

                <h4 className="subheading">
                  A. Data collection and uses{' '}
                </h4>
                <p className="privacy__body">
                  1) Data provided by users. This includes:
                </p>
                <p className="privacy__body">
                  User profile: We collect data when users create or update
                  their Autzu accounts. This may include their name, email,
                  phone number, login name and password, address, profile
                  picture, payment information (including related payment
                  verification information) and driver’s license. We may
                  use the photos submitted by users to verify their
                  identities, such as through facial recognition
                  technologies.
                </p>
                <p className="privacy__body">
                  User content: We collect the information users submit
                  when they contact Autzu customer support, provide ratings
                  or feedback.
                </p>
                <p className="privacy__body">
                  2) Data created during use of our services. This
                  includes:
                </p>
                <p className="privacy__body">
                  Location data: Autzu collects this data when the Autzu
                  app is running in the foreground (app open and on-screen)
                  or background (app open but not on-screen) of their
                  mobile device. We use this data to enhance your use of
                  our apps, including to improve safety features, and
                  prevent and detect fraud.
                </p>
                <p className="privacy__body">
                  Usage data: We collect data about how users interact with
                  our services. This includes data such as access dates and
                  times, app features or pages viewed, app crashes and
                  other system activity, type of browser, and third-party
                  sites or services used before interacting with our
                  services. In some cases, we collect this data through
                  cookies, pixels, tags, and similar tracking technologies
                  that create and maintain unique identifiers.
                </p>
                <p className="privacy__body">
                  Device data: We may collect data about the devices used
                  to access our services, including the hardware models,
                  device IP address, operating systems and versions,
                  software, preferred languages, unique device identifiers,
                  advertising identifiers, serial numbers, device motion
                  data, and mobile network data.
                </p>
                <p className="privacy__body">
                  Rental vehicles data: We collect data generated by rental
                  vehicles, when they’re in use. This includes the date and
                  time of use, and the location, route, and distance
                  traveled. To the extent permitted by law, the location
                  data collected from the rental device during the trip
                  will be linked to the renter’s account, even if they have
                  not enabled Autzu to collect location data from their
                  mobile device.
                </p>
                <p className="privacy__body">
                  3) Data from other sources. This includes:
                </p>
                <p className="privacy__body">
                  <ul>
                    <li>
                      User feedback, such as ratings, feedback, or
                      compliments.
                    </li>
                    <li>
                      Users participating in our referral programs. For
                      example, when a user refers another person, we
                      receive the referred person’s personal data from that
                      user.
                    </li>
                    <li>
                      Users or others providing information in connection
                      with claims or disputes.
                    </li>
                    <li>
                      Insurance, vehicle, or financial services providers
                      for drivers.
                    </li>
                    <li>Publicly available sources.</li>
                    <li>Marketing service providers.</li>
                  </ul>
                </p>
                <p className="privacy__body">
                  Autzu may combine the data collected from these sources
                  with other data in its possession.
                </p>
                <h4 className="subheading">
                  B. How we use personal data.
                </h4>
                <p className="privacy__body">
                  1) Providing services and features. Autzu uses the data
                  we collect to provide, personalize, maintain, and improve
                  our products and services.
                </p>
                <p className="privacy__body">
                  This includes using the data to:
                </p>
                <p className="privacy__body">
                  <ul>
                    <li>Create and update users’ accounts.</li>
                    <li>Verify drivers’ identity.</li>
                    <li>
                      Offer, process, or facilitate payments for our
                      services.
                    </li>
                    <li>
                      Offer, obtain, provide, or facilitate insurance,
                      vehicle, invoicing, or financing solutions in
                      connection with our services.
                    </li>
                    <li>
                      Perform internal operations necessary to provide our
                      services, including to troubleshoot software bugs and
                      operational problems; to conduct data analysis,
                      testing, and research; and to monitor and analyze
                      usage and activity trends.
                    </li>
                  </ul>
                </p>
                <p className="privacy__body">
                  2) Safety and security. We use personal data to help
                  maintain the safety, security, and integrity of our
                  services and users. This includes:
                </p>
                <p className="privacy__body">
                  <ul>
                    <li>
                      Using data from drivers’ devices to help identify
                      that the drivers’ locations match that of the vehicle
                      at all times. This is to combat fraud, theft and
                      unauthorized use of Autzu vehicles.
                    </li>
                    <li>
                      Using data from drivers’ devices to help identify
                      unsafe driving behavior such as speeding or harsh
                      braking and acceleration, and to inform them of safer
                      driving practices. We also use data from drivers’
                      devices to verify the type of vehicles they used to
                      provide trips.
                    </li>
                    <li>
                      Using device, location, profile, usage, and other
                      data to prevent, detect, and combat fraud or unsafe
                      activities.
                    </li>
                  </ul>
                </p>

                <p className="privacy__body">
                  3) Customer support. Autzu uses the information we
                  collect (including recordings of customer support calls
                  with notice to and the consent of the user) to provide
                  customer support, including to:
                </p>
                <p className="privacy__body">
                  <ul>
                    <li>
                      Direct questions to the appropriate customer support
                      person
                    </li>
                    <li>Investigate and address user concerns</li>
                    <li>
                      Monitor and improve our customer support responses
                      and processes
                    </li>
                  </ul>
                </p>
                <p className="privacy__body">
                  4) Research and development. We may use the data we
                  collect for testing, research, analysis, product
                  development, and machine learning to improve the user
                  experience. This helps us to improve and enhance the
                  safety and security of our services, improve our ability
                  to prevent the use of our services for illegal or
                  improper purposes, develop new features and products, and
                  facilitate insurance and finance solutions in connection
                  with our services.
                </p>
                <p className="privacy__body">
                  5) Marketing. Autzu may use the data we collect to market
                  our services to our users. This includes sending users
                  communications about Autzu services, features,
                  promotions, sweepstakes, studies, surveys, news, updates,
                  and events. We may use the data we collect to personalize
                  the marketing communications (including advertisements)
                  that we send, including based on user location, past use
                  of Autzu’s services, and user preferences and settings.
                </p>
                <p className="privacy__body">
                  6) Non-marketing communications. Autzu may use the data
                  we collect to generate and provide users with receipts;
                  inform them of changes to our terms, services, or
                  policies; or send other communications that aren’t for
                  the purpose of marketing the services or products of
                  Autzu or its partners.
                </p>
                <p className="privacy__body">
                  7) Legal proceedings and requirements. We may use the
                  personal data we collect to investigate or address claims
                  or disputes relating to use of Autzu’s services, or as
                  otherwise allowed by applicable law, or as requested by
                  regulators, government entities, and official inquiries.
                </p>
                <p className="privacy__body">
                  8) Automated decision-making. We use personal data to
                  make automated decisions relating to use of our services.
                  This includes:
                </p>
                <p className="privacy__body">
                  <ul>
                    <li>
                      Determining drivers’ ratings, and deactivating
                      drivers with low ratings.
                    </li>
                    <li>
                      Deactivating drivers’ who are identified as having
                      engaged in fraud or activities that may otherwise
                      harm Autzu, its users, and others. In some cases,
                      such as when a user is determined to be abusing
                      Autzu’s referral program, such behavior may result in
                      automatic deactivation.
                    </li>
                  </ul>
                </p>
                <p className="subheading">
                  C. Cookies and third-party technologies
                </p>
                <p className="privacy__body">
                  Cookies are small text files that are stored on browsers
                  or devices by websites, apps, online media, and
                  advertisements. Autzu uses cookies and similar
                  technologies for purposes such as:
                </p>
                <p className="privacy__body">
                  <ul>
                    <li>Authenticating users</li>
                    <li>Remembering user preferences and settings</li>
                    <li>Determining the popularity of content</li>
                    <li>
                      Delivering and measuring the effectiveness of
                      advertising campaigns
                    </li>
                    <li>
                      Analyzing site traffic and trends, and generally
                      understanding the online behaviors and interests of
                      people who interact with our services
                    </li>
                  </ul>
                </p>
                <p className="privacy__body">
                  We may also allow others to provide audience measurement
                  and analytics services for us, to serve advertisements on
                  our behalf across the Internet, and to track and report
                  on the performance of those advertisements. These
                  entities may use cookies, web beacons, SDKs, and other
                  technologies to identify the devices used by visitors to
                  our websites, as well as when they visit other online
                  sites and services.
                </p>
                <p className="subheading">
                  D. Data sharing and disclosure
                </p>
                <p className="privacy__body">
                  Autzu may share the data we collect:
                </p>
                <p className="privacy__body">
                  1) With Autzu service providers and business partners.
                </p>
                <p className="privacy__body">
                  This includes sharing data with:
                </p>
                <p className="privacy__body">
                  <ul>
                    <li>
                      Autzu business partners. For example, if a user
                      requests a service through a partnership or
                      promotional offering made by a third party, Autzu may
                      share certain data with those third parties. This may
                      include, for example, other services, platforms,
                      apps, or websites that integrate with our APIs;
                      vehicle suppliers or services; those with an API or
                      service with which we integrate; or other Autzu
                      business partners and their users in connection with
                      promotions, contests, or specialized services.
                    </li>
                    <li>Payment processors and facilitators.</li>
                    <li>Cloud storage providers</li>
                    <li>
                      Marketing partners and marketing platform providers,
                      including social media advertising services
                    </li>
                    <li>Data analytics providers</li>
                    <li>
                      Research partners, including those performing surveys
                      or research projects in partnership with Autzu or on
                      Autzu’s behalf
                    </li>
                    <li>
                      Vendors that assist Autzu to enhance the safety and
                      security of its apps
                    </li>
                    <li>
                      Consultants, lawyers, accountants, and other
                      professional service providers
                    </li>
                    <li>Insurance and financing partners</li>
                    <li>
                      Debt collection agencies. For example, in the event
                      that the driver defaults in the payment of any monies
                      owing to Autzu, or other parties involved in an
                      accident with the vehicle while on hire to the
                      driver; or any organizations responsible for the
                      processing or handling of traffic related
                      infringements; and the driver hereby authorizes the
                      disclosure of their personal information for such
                      purposes.
                    </li>
                  </ul>
                </p>
                <p className="privacy__body">
                  2) For legal reasons or in the event of a dispute
                </p>
                <p className="privacy__body">
                  Autzu may share users’ personal data if we believe it’s
                  required by applicable law, regulation, operating license
                  or agreement, legal process or governmental request, or
                  where the disclosure is otherwise appropriate due to
                  safety or similar concerns.
                </p>
                <p className="privacy__body">
                  This includes sharing personal data with law enforcement
                  officials, public health officials, other government
                  authorities, airports (if required by the airport
                  authorities as a condition of operating on airport
                  property), or other third parties as necessary to enforce
                  our Terms of Service, user agreements, or other policies;
                  to protect Autzu’s rights or property or the rights,
                  safety, or property of others; or in the event of a claim
                  or dispute relating to the use of our services. If you
                  use another person’s credit card, we may be required by
                  law to share your personal data, including trip or order
                  information, with the owner of that credit card.
                </p>
                <p className="privacy__body">
                  This also includes sharing personal data with others in
                  connection with, or during negotiations of, any merger,
                  sale of company assets, consolidation or restructuring,
                  financing, or acquisition of all or a portion of our
                  business by or into another company.
                </p>
                <p className="privacy__body">3) With consent</p>
                <p className="privacy__body">
                  Autzu may share a user’s personal data other than as
                  described in this notice if we notify the user and they
                  consent to the sharing.
                </p>
                <p className="subheading">
                  E. Data retention and deletion
                </p>
                <p className="privacy__body">
                  Autzu retains user data for as long as necessary for the
                  purposes described above. Users may request deletion of
                  their accounts at any time. Autzu may retain user data
                  after a deletion request due to legal or regulatory
                  requirements or for the reasons stated in this policy.
                </p>
                <p className="privacy__body">
                  Users may request deletion of their account at any time
                  by emailing{' '}
                  <a href="mailto:drivers@autzu.com">drivers@autzu.com</a>{' '}
                  with the data deletion request.
                </p>
                <p className="privacy__body">
                  Following an account deletion request, Autzu deletes the
                  user’s account and data, unless they must be retained due
                  to legal or regulatory requirements, for purposes of
                  safety, security, and fraud prevention, or because of an
                  issue relating to the user’s account such as an
                  outstanding credit or an unresolved claim or dispute.
                  Because we are subject to legal and regulatory
                  requirements relating to drivers and delivery persons,
                  this generally means that we retain their account and
                  data for a minimum of 7 years after a deletion request.
                  Data is generally deleted within 90 days of a deletion
                  request, except where retention is necessary for the
                  above reasons.
                </p>
                <p className="subheading">F. Updates to this notice</p>
                <p className="privacy__body">
                  We may occasionally update this notice. Use of our
                  services after an update constitutes consent to the
                  updated notice to the extent permitted by law.
                </p>
                <p className="privacy__body">
                  We may occasionally update this notice. If we make
                  significant changes, we will notify users in advance of
                  the changes through the Autzu app or through other means,
                  such as email. We encourage users to periodically review
                  this notice for the latest information on our privacy
                  practices.
                </p>
                <br />
                <p
                  className="privacy__body"
                  style={{ borderTop: 'solid 1px black' }}>
                  Updated by the Autzu Legal Team on March 1, 2021
                </p>
              </div>
            </div>
          </div>
        </div>
        {window.innerWidth >= 768 && pathname.includes('tor') ? (
          <TorontoFooter />
        ) : pathname.includes('sf') ? (
          <SFFooter />
        ) : pathname.includes('ott') ? (
          <OttawaFooter />
        ) : (
          <NYCFooter />
        )}
      </div>
    </Fragment>
  );
};

export default withRouter(NewPrivacy);



// WEBPACK FOOTER //
// ./src/components/Static/NewPrivacy.js